import pluralize from 'pluralize'

import styles from './OrderingReportList.module.css'

import type { GapReport } from '@pepper/utils/src/types/seo'

interface Props {
  reports: GapReport[]
}

const REPORT_SHOW_LIMIT = 3

function OrderingReportList({ reports }: Props) {
  const visibleReports = reports.slice(0, REPORT_SHOW_LIMIT)
  const extraReports = reports.slice(REPORT_SHOW_LIMIT)

  if (reports.length <= 1) return null

  return (
    <section className={styles.container}>
      <strong className={styles.title}>
        {reports.length} Reports selected{' '}
        <span className={styles.required}>*</span>
      </strong>

      <div className={styles.list}>
        {visibleReports.map(report => (
          <div key={report.id} className={styles.item}>
            <p>{report.page_title}</p>
          </div>
        ))}
        {extraReports.length > 0 && (
          <div className={styles.item}>
            <p>
              {`+${extraReports.length} more ${pluralize(
                'report',
                extraReports.length
              )}`}
            </p>
          </div>
        )}
      </div>
    </section>
  )
}

export default OrderingReportList
